import type { Context } from '@nuxt/types';
import { COOKIE_NAME_SOCIAL_SIGNUP } from '~/components/common/constants';

/**
 * @description After social signup, we want to track the event `global__user__sign-up`.
 * A cookie with name `trackSocialSignup` is being sent from the server which is used to check and log the event.
 * @see [social_sessions_controller.rb](https://github.com/Bravado-network/bravado/blob/master/backend/app/controllers/social_sessions_controller.rb#L123)
 */
// FIXME: better to move to `setUser` in analytics plugin, because there is a case
//        when we didn't setup a user yet
export const trackSocialSignUp = ({ app: { $analytics, $cookies, store } }: Context) => {
  window.onNuxtReady(() => {
    const socialSignUp = $cookies.get(COOKIE_NAME_SOCIAL_SIGNUP);
    if (socialSignUp) {
      // NOTE: seems like amplitudeUser isn't available for most users
      $analytics.logSignUp(socialSignUp, store?.state.auth.user.amplitudeUser);
      $cookies.remove(COOKIE_NAME_SOCIAL_SIGNUP);
    }
  });
};
